import React, { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';

import useSearch from '../../hooks/useSearch';
import { useTabs } from '../../hooks/useTabs';
import { useSaveSettings } from '../../hooks/useSaveSettings';
import { CATEGORIES, SUBCATEGORIES } from '../../common/categories';
import { fieldsReducer, initFieldsState, mapToSettings } from './desktopApplicationReducer';

import Category from '../../components/Category/Category';
import DesktopMessagingServices from '../../components/DesktopMessagingServices/DesktopMessagingServices';
import DesktopNotification from '../../components/DesktopNotification/DesktopNotification';
import OTPNotification from '../../components/OTPNotification/OTPNotification';
import ApplicationSettings from '../../components/ApplicationSettings/ApplicationSettings';
import { filterFieldsBySystemMode } from '../../common/utils';
import { USER_ENGAGEMENT_PAGE_KEYS } from '@silverfort-nodelibs/common/utils/consts';
import { httpPost } from '../../../utils';
import { useVisibleTabs } from '../../hooks/lockedFeatures/useVisibleTabs';

const { DESKTOP_APPLICATION } = CATEGORIES;
const { APPLICATION_SETTINGS, DESKTOP_MESSAGING_SERVICES, DESKTOP_NOTIFICATION, OTP_NOTIFICATION } = SUBCATEGORIES;

const DesktopApplication = ({ saveFunc, disableSave, systemMode }) => {
    const settings = useSelector((state) => state.settings.settings);

    const [fields, dispatch] = useReducer(fieldsReducer, { settings }, initFieldsState);
    const visibleFields = useVisibleTabs(useSearch(filterFieldsBySystemMode(fields, systemMode)));
    const [selectedTab, setSelectedTab] = useTabs(DESKTOP_APPLICATION, visibleFields);
    const [save, discard] = useSaveSettings(saveFunc, settings, mapToSettings, fields, selectedTab, dispatch);

    let content = null;
    if (visibleFields[APPLICATION_SETTINGS.ID] && selectedTab === APPLICATION_SETTINGS.ID) {
        content = (
            <ApplicationSettings
                fields={visibleFields[APPLICATION_SETTINGS.ID].fields}
                dispatch={dispatch}
                showAryaHAToggle={'AryaHAMode' in settings}
            />
        );
    } else if (visibleFields[DESKTOP_MESSAGING_SERVICES.ID] && selectedTab === DESKTOP_MESSAGING_SERVICES.ID) {
        content = (
            <DesktopMessagingServices
                fields={visibleFields[DESKTOP_MESSAGING_SERVICES.ID].fields}
                dispatch={dispatch}
            />
        );
    } else if (visibleFields[DESKTOP_NOTIFICATION.ID] && selectedTab === DESKTOP_NOTIFICATION.ID) {
        content = (
            <DesktopNotification
                fields={visibleFields[DESKTOP_NOTIFICATION.ID].fields}
                dispatch={dispatch}
                defaultData={{
                    ...settings.DefaultNotificationConfiguration,
                    enableWafCompliantValidator: settings.enableWafCompliantValidator
                }}
            />
        );
    } else if (visibleFields[OTP_NOTIFICATION.ID] && selectedTab === OTP_NOTIFICATION.ID) {
        content = (
            <OTPNotification
                fields={visibleFields[OTP_NOTIFICATION.ID].fields}
                dispatch={dispatch}
                defaultData={{
                    ...settings.DefaultOtpNotificationConfiguration,
                    enableWafCompliantValidator: settings.enableWafCompliantValidator
                }}
            />
        );
    }

    useEffect(() => {
        httpPost('/data/userEngagement', { pageId: USER_ENGAGEMENT_PAGE_KEYS.SETTINGS_DESKTOP });
    }, []);

    return (
        <Category
            category={DESKTOP_APPLICATION}
            fields={fields}
            visibleFields={visibleFields}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            saveSettings={save}
            discard={() => discard(false)}
            discardAll={() => discard(true)}
            disableSave={disableSave}>
            {content}
        </Category>
    );
};

export default DesktopApplication;
